export default "__VITE_PUBLIC_ASSET__7a43e411__"